import { css } from 'lit';

export const styles = css`:host{--background: var(--ig-navbar-background, var(--ig-primary-800));--text-color: var(--ig-navbar-text-color, var(--ig-primary-800-contrast));--ig-theme: material}`;
